import type { Session, User } from '@supabase/supabase-js';
import { supabase } from './supabase';

export async function getCurrentSession(): Promise<Session | null> {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error) {
    console.error('Failed to fetch Supabase session', error);
    return null;
  }

  return session ?? null;
}

export async function getCurrentUser(): Promise<User | null> {
  const session = await getCurrentSession();
  return session?.user ?? null;
}

export function buildLoginRedirect(request: Request): string {
  const url = new URL(request.url);
  const redirectTo = `${url.pathname}${url.search}`;

  const searchParams = new URLSearchParams({
    redirectTo,
  });

  return `/login?${searchParams.toString()}`;
}

/**
 * Check if the current user is authenticated
 */
export async function isAuthenticated(): Promise<boolean> {
  const user = await getCurrentUser();
  return !!user;
}

/**
 * Get the user's ID if authenticated, null otherwise
 */
export async function getUserId(): Promise<string | null> {
  const user = await getCurrentUser();
  return user?.id ?? null;
}
